import { useContext } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import IntlMessages from 'util/IntlMessages';
import { ReportContext } from '../../../../contexts/ReportContext';
import styles from './styles.module.less';
import { useIntl } from 'react-intl';
import { PATHS } from '@src/containers/App/TimeTracker/constants';
import PeriodEmptyUserData from './components/PeriodEmptyUserData';
import { useModificationReport } from '@src/containers/App/TimeTracker/hooks/useModificationReport';

const EmptyUserData = ({ reportType = '', queriedPeriod = '' }) => {
  const location = useLocation();
  const intl = useIntl();
  const query = new URLSearchParams(location.search);
  const startDate = query.get('startDate');
  const endDate = query.get('endDate');

  const { selectedIndividualUser } = useContext(ReportContext);
  const { emptyStateText: emptyStateTextModificationReport } = useModificationReport();

  if (reportType === PATHS.HOLIDAYS) {
    const text = intl.formatMessage({ id: 'timeTracker.reports.emptyUserData.holidays' });
    return (
      <div className="gx-text-center gx-mt-4">
        <h3 className={styles.emptyUserData}>
          {selectedIndividualUser &&
            intl.formatMessage(
              { id: 'timeTracker.reports.emptyUserData.selectedUser' },
              {
                name: `${selectedIndividualUser?.firstName} ${selectedIndividualUser?.lastName}`,
              },
            )}
        </h3>
        <PeriodEmptyUserData
          startDate={startDate}
          endDate={endDate}
          queriedPeriod={queriedPeriod}
        />
        {selectedIndividualUser && (
          <h3 className={`${styles.emptyUserData} gx-text-dark`}>{text}</h3>
        )}
      </div>
    );
  }

  if (reportType === PATHS.MODIFICATIONS) {
    return (
      <div className="gx-text-center gx-mt-4">
        {emptyStateTextModificationReport.user && (
          <h3 className={styles.emptyUserData}>
            {intl.formatMessage(
              { id: 'timeTracker.reports.emptyUserData.selectedUser' },
              {
                name: emptyStateTextModificationReport.user,
              },
            )}
          </h3>
        )}
        <PeriodEmptyUserData
          startDate={startDate}
          endDate={endDate}
          queriedPeriod={queriedPeriod}
        />
        <h3>{emptyStateTextModificationReport.message}</h3>
      </div>
    );
  }

  return (
    <div className="gx-text-center gx-mt-4">
      {selectedIndividualUser && (
        <h3 className={styles.emptyUserData}>
          {intl.formatMessage(
            { id: 'timeTracker.reports.emptyUserData.selectedUser' },
            { name: `${selectedIndividualUser?.firstName} ${selectedIndividualUser?.lastName}` },
          )}
        </h3>
      )}

      <PeriodEmptyUserData
        startDate={startDate}
        endDate={endDate}
        queriedPeriod={queriedPeriod}
      />

      <h3>
        <IntlMessages id="work.direction.table.emptyState" />
      </h3>
    </div>
  );
};

export default EmptyUserData;
